import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { WHY_CHOOSE } from "@/lib/siteData";

export default function WhyChoose() {
    return (
        <section id="why" data-testid="why-choose" className="relative py-24 md:py-32">
            <div className="max-w-7xl mx-auto px-5 md:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12">
                <div className="lg:col-span-5 lg:sticky lg:top-28 self-start">
                    <div className="flex items-center gap-3 mb-5">
                        <span className="divider-gold" />
                        <span className="uppercase tracking-[0.28em] text-xs text-gold font-medium">
                            Why Choose Us
                        </span>
                    </div>
                    <h2 className="font-display text-4xl md:text-5xl leading-tight tracking-tight">
                        Clarity now.<br />
                        <span className="italic text-gold">Confidence forever.</span>
                    </h2>
                    <p className="mt-6 text-foreground/70 leading-relaxed max-w-md">
                        Every render, walkthrough, and drawing we deliver is engineered to answer
                        one question: <em>does this feel right?</em>
                    </p>
                </div>

                <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-5">
                    {WHY_CHOOSE.map((w, i) => (
                        <motion.div
                            key={w.title}
                            data-testid={`why-card-${i}`}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-80px" }}
                            transition={{ duration: 0.5, delay: (i % 2) * 0.08 }}
                            className="p-6 rounded-xl border hairline bg-card"
                        >
                            <div className="flex items-start gap-4">
                                <div className="mt-1 h-7 w-7 rounded-full bg-gold/10 border border-gold/30 grid place-items-center">
                                    <Check className="h-4 w-4 text-gold" />
                                </div>
                                <div>
                                    <h3 className="font-display text-lg mb-1">{w.title}</h3>
                                    <p className="text-sm text-muted-foreground">{w.desc}</p>
                                </div>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
